const FORMAT_BY_MIMETYPE: Record<string, string> = {
  'application/pdf': 'PDF',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'DOCX',
  'application/msword': 'DOC',
  'image/png': 'PNG',
  'image/jpeg': 'JPG',
}

/** Short, user-facing file format (e.g. "PDF", "DOCX") instead of the raw mimetype. */
export const getFileFormatLabel = (file: Pick<FileItem, 'mimetype' | 'name'>): string => {
  const format = file.mimetype ? FORMAT_BY_MIMETYPE[file.mimetype] : undefined
  if (format) return format

  const extension = /\.([a-z0-9]{2,5})$/i.exec(file.name)?.[1]
  return extension ? extension.toUpperCase() : 'Datei'
}

export const DOC_ICON: Record<string, { icon: string; color: string }> = {
  pdf: { icon: 'picture_as_pdf', color: '#D32F2F' },
  doc: { icon: 'description', color: '#0288D1' },
  img: { icon: 'image', color: '#2E7D32' },
}

export const getDocKind = (file: FileItem): 'pdf' | 'doc' | 'img' => {
  const mime = file.mimetype ?? ''
  const name = file.name.toLowerCase()
  if (mime.includes('pdf') || name.endsWith('.pdf')) return 'pdf'
  if (mime.startsWith('image/') || /\.(png|jpe?g|gif|webp|svg)$/i.test(name)) return 'img'
  return 'doc'
}
